export default "__VITE_ASSET__Ci1cTkxS__"